import api from '../../api/authentication.js';
import router from '../../routes/index.js';
import { can } from '../../src/helpers/permissions';

function landingPath(user) {
    const abilities = user && user.abilities ? user.abilities : [];
    if (can(abilities, 'get-routes')) return '/routes';
    if (can(abilities, ['get-users', 'authorization'])) return '/users';
    return '/home';
}

const state = { loading: false, isLoggedIn: false };

const mutations = {
    SET_LOADING(state, value) { state.loading = value; },
    SET_LOGINSTATUS(state, value) { state.isLoggedIn = value; },
};

const actions = {
    async login_server({ commit, dispatch }, credentials) {
        commit('SET_LOADING', true);
        try {
            const response = await api.login_server(credentials);
            commit('SET_LOGINSTATUS', true);
            dispatch('configuration/setUserAuth', response.data.user, { root: true });
            router.push(landingPath(response.data.user));
            return response;
        } catch (error) {
            const message = error.response && error.response.data && error.response.data.message
                ? error.response.data.message : 'No fue posible iniciar sesión.';
            dispatch('notifications/add', { color: 'error', visibility: true, timeout: 5000, text: message }, { root: true });
            return null;
        } finally {
            commit('SET_LOADING', false);
        }
    },
    async check_token({ commit, dispatch }) {
        try {
            const response = await api.check_token();
            commit('SET_LOGINSTATUS', true);
            dispatch('configuration/setUserAuth', response.data.user, { root: true });
            if (router.currentRoute.name === 'login') router.push(landingPath(response.data.user));
        } catch (error) {
            commit('SET_LOGINSTATUS', false);
            dispatch('configuration/setUserAuth', { id: null, abilities: [], roles: [] }, { root: true });
            if (router.currentRoute.name !== 'login') router.push('/login');
        }
    },
    async logout({ commit, dispatch }) {
        try { await api.logout(); } catch (error) { /* Clear local state even if the server session expired. */ }
        commit('SET_LOGINSTATUS', false);
        dispatch('configuration/setUserAuth', { id: null, abilities: [], roles: [] }, { root: true });
        router.push('/login');
    },
};

export default { namespaced: true, state, mutations, actions };
